import { Component } from 'react';

export class EmpleadoDetalleErrorBoundary extends Component {
  state = { error: false };

  static getDerivedStateFromError() {
    return { error: true };
  }

  componentDidCatch(error, info) {
    console.error('Error al mostrar el detalle del empleado', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="container mt-3" role="alert">
          <p>No se pudo mostrar el detalle del empleado.</p>
          <button type="button" className="btn btn-primary-mem" onClick={() => this.setState({ error: false })}>
            Reintentar
          </button>
          <a className="btn btn-link" href="/empleados">Volver a empleados</a>
        </div>
      );
    }
    return this.props.children;
  }
}